import script from "./VoucherUpload.vue?vue&type=script&setup=true&lang=ts"
export * from "./VoucherUpload.vue?vue&type=script&setup=true&lang=ts"

import "./VoucherUpload.vue?vue&type=style&index=0&id=b2621838&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b2621838"]])

export default __exports__